export const tags = [
    'StudyInstanceUID',
    'SeriesInstanceUID',
    'SeriesDescription',
    'SeriesNumber',
    'SeriesDate',
    'SeriesTime',
    'Modality',
    'SOPInstanceUID',
    'SOPClassUID',
];
